export default __webpack_public_path__ + "static/media/vehicleMarkerCallout_Nay.919c08a8.svg";